module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BoldItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BoldItalic.ttf
// module id = 58
// module chunks = 8